import type { SupervisorCamerasSearch } from '@/features/supervisor/types/supervisor';

/** Applies an organization scope chosen by a navigation control. */
export function supervisorCamerasScopeSearch(
  search: SupervisorCamerasSearch,
  organizationId?: string,
): SupervisorCamerasSearch {
  return {
    ...search,
    organizationId: organizationId ? [organizationId] : undefined,
  };
}
